import { Component } from 'preact';
import DeckTile, { DeckTileText } from './DeckTile';
import {
  GOLD, ACCENT_GOLD, TEXT_MUTED, PANEL_BG, PANEL_BORDER, GOLD_BTN, CornerPlating,
} from '../lib/medievalTheme';
import { timeAgo } from '../utils/arena/timeFormat';
import { playUI, UI } from '../utils/arena/uiSounds';
import { t } from '../localization/t';

// Shown after a successful Alpha precon purchase. Replaces the
// pack-opening flow for deterministic sealed product. The deck
// preview is rendered with the *exact* slot composition used by
// DeckGallery, at the same 22cqw cell width, so the player sees
// the tile the way it will appear in their collection.
export default class PreconCollectedModal extends Component {
  handleAccept = () => {
    playUI(UI.CONFIRM);
    this.props.onAccept?.();
  };

  render() {
    const { deck, sorceryCards, quantity = 1 } = this.props;
    if (!deck) return null;

    const heading = quantity > 1
      ? t('{n} Decks Added to Your Collection', { n: quantity })
      : t('Deck Added to Your Collection');

    // Mode pill. Same renderer DeckGallery uses for each tile.
    const deckMode = deck.gameMode || 'constructed';
    const isSandbox = deckMode === 'sandbox';
    const isPeasant = deckMode === 'peasant';
    const modePill = isSandbox ? (
      <span className="px-1.5 py-0.5 rounded-full font-semibold" style={{ fontSize: '0.5cqw', background: 'rgba(167,139,250,0.16)', color: '#c4b5fd', border: '1px solid rgba(167,139,250,0.35)' }} title={t('Sandbox deck. Not eligible for ranked play.')}>{t('Sandbox')}</span>
    ) : isPeasant ? (
      <span className="px-1.5 py-0.5 rounded-full font-semibold" style={{ fontSize: '0.5cqw', background: 'rgba(134,192,107,0.16)', color: '#a3d488', border: '1px solid rgba(134,192,107,0.35)' }} title={t('Peasant deck. Ordinary and Exceptional cards only. Ranked-eligible.')}>{t('Peasant')}</span>
    ) : (
      <span className="px-1.5 py-0.5 rounded-full font-semibold" style={{ fontSize: '0.5cqw', background: `${GOLD} 0.1)`, color: ACCENT_GOLD, border: `1px solid ${GOLD} 0.28)` }} title={t('Constructed deck. Eligible for ranked play.')}>{t('Constructed')}</span>
    );

    const footerLeft = (
      <>
        {DeckTileText.title(deck.name)}
        <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
          {deck.savedAt ? <span style={{ color: TEXT_MUTED, fontSize: '0.58cqw' }}>{timeAgo(deck.savedAt)}</span> : null}
          {modePill}
        </div>
      </>
    );

    return (
      <div
        className="fixed inset-0 z-[80] flex items-center justify-center bg-black/75 backdrop-blur-sm"
        onClick={this.handleAccept}
      >
        <div
          className="relative flex flex-col items-center"
          style={{
            padding: '2cqw 3cqw 1.8cqw',
            background: PANEL_BG,
            backdropFilter: 'blur(8px)',
            border: `1px solid ${PANEL_BORDER}`,
            borderRadius: 'var(--radius-lg)',
            boxShadow: `0 0 40px rgba(0,0,0,0.6), 0 0 20px ${GOLD} 0.08)`,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <CornerPlating position="top-left" />
          <CornerPlating position="top-right" />
          <CornerPlating position="bottom-left" />
          <CornerPlating position="bottom-right" />

          <h2
            className="arena-heading text-center mb-4"
            style={{
              color: '#f0d990',
              fontSize: '1.3cqw',
              letterSpacing: '0.08em',
              textShadow: '0 2px 4px rgba(0,0,0,0.9), 0 0 12px rgba(212,168,67,0.25)',
            }}
          >
            {heading}
          </h2>

          {/* DeckTile at the same 22cqw cell width DeckGallery uses,
              so the preview is pixel-identical to the tile the player
              will see in their collection. */}
          <div style={{ width: '22cqw' }}>
            <DeckTile
              deck={deck}
              sorceryCards={sorceryCards}
              footerLeftSlot={footerLeft}
            />
          </div>

          <button
            type="button"
            className="mt-5 px-10 py-2.5 text-sm font-semibold arena-heading transition-all hover:scale-[1.03] active:scale-[0.97]"
            style={{ ...GOLD_BTN, borderRadius: 'var(--radius-sm)' }}
            onClick={this.handleAccept}
            data-sound={UI.CONFIRM}
          >
            {t('Accept')}
          </button>
        </div>
      </div>
    );
  }
}
